import React, { Fragment } from 'react';
import spinner from '../img/spinner.gif';

const Spinner = (props) => {
  const width = props.width || '100px';
  return (
    <Fragment>
      <img src={spinner} style={{ width, margin: 'auto', display: 'block' }} alt='Loading' />
    </Fragment>
  );
};

export default Spinner;
